<template>
  <div>
    <SupplierCategoryDialog ref="supplierCategoryDialog" @update="list" />
    <SupplierCategoryRelationDialog
      ref="supplierCategoryRelationDialog"
      @update="list"
    />
    <v-row justify="end" class="mb-4 ml-0 mr-0 mt-0" dense>
      <!-- <v-col cols="3">
        <v-btn block color="primary" :disabled="!selected.length"
          >Загрузить свойства товаров</v-btn
        >
      </v-col> -->
      <v-spacer />
      <v-col cols="3">
        <v-btn block color="primary" @click="getCategoriesByApi()"
          >Загрузить категории</v-btn
        >
      </v-col>
      <v-col cols="3">
        <v-progress-linear
          indeterminate
          v-show="isUpdatingPrices"
        ></v-progress-linear>
        <v-btn
          block
          color="primary"
          @click="updatePrice()"
          :disabled="isUpdatingPrices"
          >Пересчитать и обновить цены</v-btn
        >
      </v-col>
    </v-row>
    <v-data-table-server
      :headers="headers"
      :items="categories"
      :items-length="totalItems"
      :loading="loading"
      :items-per-page="100"
      item-value="name"
      class="elevation-1"
      @update:options="options = $event"
      fixed-header
      show-select
      v-model="selected"
    >
      <template v-slot:item.supplierCategoryName="{ item }">
        <td
          @click="createTab(item.props.title)"
          class="supplier-category-name font-weight-bold"
        >
          <span>{{ item.value.supplierCategoryName }} </span>
        </td>
      </template>

      <template v-slot:item.actions="{ item }">
        <td>
          <v-btn
            flat
            icon="$mdiRelationOneToOne"
            @click="openRelationDialog(item.value)"
          ></v-btn>

          <!--<v-btn
            :disabled="
              item.value.supplierGoodsStockBackgroundJob &&
              item.value.supplierGoodsStockBackgroundJob.state !==
                'Succeeded' &&
              item.value.supplierGoodsStockBackgroundJob.state !== 'Failed'
            "
            flat
            icon="$mdiStorageTank"
            @click="loadSupplierProducts(item.value)"
          >
          </v-btn>
          <span>
            <v-tooltip
              v-if="item.value.supplierGoodsStockBackgroundJob"
              :text="
                item.value.supplierGoodsStockBackgroundJob
                  ? item.value.supplierGoodsStockBackgroundJob.stage
                  : ''
              "
              location="top"
            >
              <template v-slot:activator="{ props }">
                <v-progress-circular
                  v-if="
                    item.value.supplierGoodsStockBackgroundJob &&
                    item.value.supplierGoodsStockBackgroundJob.state ===
                      'Processing'
                  "
                  indeterminate
                  color="primary"
                  v-bind="props"
                ></v-progress-circular>
              </template>
            </v-tooltip>
            <v-tooltip
              v-if="!item.value.supplierGoodsStockBackgroundJob"
              text="Загрузок товаров по этой категории не было
              "
              location="top"
            >
              <v-icon
                icon="$mdiAlphaXCircleOutline"
                color="warning"
                v-bind="props"
              />
            </v-tooltip>
          </span>-->
        </td>
      </template>
    </v-data-table-server>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import SupplierCategoryDialog from "@/components/Dialogs/SupplierCategoryDialog/SupplierCategoryDialog";
import SupplierCategoryRelationDialog from "@/components/Dialogs/SupplierCategoryRelationDialog/SupplierCategoryRelationDialog";
import { mapGetters, mapMutations } from "vuex";

const SupplierCategoryRepository = RepositoryFactory.get("supplierCategory");
const SupplierRepository = RepositoryFactory.get("suppliers");
const SupplierGoodsStockRepository =
  RepositoryFactory.get("supplierGoodsStock");

export default {
  props: ["supplier"],
  components: {
    SupplierCategoryDialog,
    SupplierCategoryRelationDialog,
  },
  data() {
    return {
      categories: [],
      loading: false,
      headers: [
        {
          title: "Категория поставщика",
          align: "start",
          sortable: false,
          key: "supplierCategoryName",
        },

        {
          title: "Категория каталога",
          align: "start",
          sortable: false,
          key: "relationCategoryName",
        },
        {
          title: "Действия",
          align: "start",
          sortable: false,
          key: "actions",
        },
      ],
      options: {},
      totalItems: 0,
      selected: [],
      isUpdatingPrices: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.list();
      },
      deep: true,
    },
    categories() {
      if (this.categories) {
        let categoriesWithProcessingJobs = this.categories.filter(
          (x) =>
            x.supplierGoodsStockBackgroundJob != null &&
            x.supplierGoodsStockBackgroundJob.state === "Processing"
        );
        for (let i = 0; i < categoriesWithProcessingJobs.length; i++) {
          this.checkBackgorundJobStatus(categoriesWithProcessingJobs[i]);
        }
      }
    },
  },
  methods: {
    ...mapMutations(["setCategoryActiveTab"]),
    async list() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;
      const result = await SupplierCategoryRepository.listBySupplierId(
        this.supplier.id,
        page,
        itemsPerPage
      );
      if (result) {
        this.totalItems = result.data.totalCount;
        this.categories = result.data.rows;
      }
      this.loading = false;
    },
    getCategoriesByApi() {
      this.$refs.supplierCategoryDialog.open(this.supplier.id, this.selected);
    },
    createTab(item) {
      let oldDataTab = this.categoryTabs.find(
        (x) =>
          x.id === `${item.id}_category` && x.supplierId === this.supplier.id
      );
      if (oldDataTab) {
        oldDataTab.name = item.supplierCategoryName;
        oldDataTab.item = item;
      } else {
        this.categoryTabs.push({
          id: item.id + "_category",
          name: item.supplierCategoryName,
          item: item,
          supplierId: this.supplier.id,
        });
      }
      this.setCategoryActiveTab(item.id + "_category");
    },
    openRelationDialog(item) {
      if (item.id) {
        this.$refs.supplierCategoryRelationDialog.openDialog(item);
      }
    },
    async loadSupplierProducts(item) {
      let response = await SupplierGoodsStockRepository.loadSupplierProducts(
        item.id,
        item.supplierId
      );
      if (response && response.data.status === "success") {
        this.checkBackgorundJobStatus(item);
      }
    },
    checkBackgorundJobStatus(item) {
      let timerId = setInterval(() => {
        SupplierGoodsStockRepository.checkLoadProductsStatus(item.id).then(
          (response) => {
            if (response && response.data.status === "success") {
              for (let i = 0; i < this.categories.length; i++) {
                if (this.categories[i].id === response.data.data.id) {
                  this.categories[i] = response.data.data;
                  let oldDataTab = this.categoryTabs.find(
                    (x) => x.id == item.id
                  );

                  if (oldDataTab) {
                    oldDataTab.item = response.data.data;
                  }
                }
              }
              if (
                response.data.data.supplierGoodsStockBackgroundJob &&
                response.data.data.supplierGoodsStockBackgroundJob.state !==
                  "Processing"
              ) {
                clearInterval(timerId);
              }
            }
          }
        );
      }, 5000);
    },
    async updatePrice() {
      this.isUpdatingPrices = true;
      await SupplierRepository.updateSuppplierPrices(
        this.supplier.id,
        this.selected.map((x) => x.supplierCategoryId)
      );
      this.isUpdatingPrices = false;
    },
  },
  computed: {
    ...mapGetters(["categoryTabs"]),
  },
};
</script>
<style scoped>
.supplier-category-name {
  cursor: pointer;
}
</style>
